export default {
  props: {
    header: {
      type: Object,
      required: true
    }
  },
  computed: {
    styles () {
      return {
        'flex': (!this.header.fixed ? '1' : '0') + ' ' + (!this.header.fixed ? '1' : '0') + ' ' + (this.header.width || '300px'),
        'min-width': '0px'
      }
    },
    classes () {
      const align = this.header.align || 'left'
      return {
        ['text-' + align]: true,
        'q-px-xs': this.header.fixed !== true
      }
    }
  }
}
